import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  FAQ: {
    id: 'FAQ.faq',
    defaultMessage: 'FAQ',
    description: '[Type: Label][Vis.: low] - FAQ link in main navigation',
  },
});

const FAQ = () => <MainNavButton href="/faq/" label={t(COPY.FAQ)} />;

export default FAQ;
export { FAQ };
